module.exports = __webpack_public_path__ + "img/fringe-3in-bullion.c4960a69.jpg";